<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">



<!--        <vs-divider color="primary" border-style="dashed" class="mt-8" position="left">4.1 Accreditation details e.g. ISO / EFSIS / BRC/Kosher/Halal/Organic?</vs-divider>-->
        <div class="vx-row mt-8 mb-4">
          <div class="vx-col md:w-full md:mb-0">
            <small>4.1 Accreditation details e.g. ISO / EFSIS / BRC/Kosher/Halal/Organic?</small>
          </div>
        </div>


        <div  v-for="(accreditation, index) in accreditations" :key="index">
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col w-1/3">
              <ValidationProvider :vid="index+'name'" :name="index+'name'" rules="required" v-slot="{ errors }">
                  <small class="label">Name of Accreditation eg: BRC</small>
                  <v-select name="acc_name" label="name" :closeOnSelect="true" v-model="accreditation.name" :options="['ISO','EFSIS','BRC', 'Kosher', 'Halal', 'Organic', 'None']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/3">
              <ValidationProvider v-if="accreditation && accreditation.name !== 'None'" :vid="index+'details'" :name="index+'details'" rules="required" v-slot="{ errors }">
                <small class="label">Details</small>
                <vs-input v-model="accreditation.details" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="acc_details" label=""  class="w-full required"  />
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/3">
              <ValidationProvider v-if="accreditation && accreditation.name !== 'None'" :vid="index+'expiry'" :name="index+'expiry'" rules="required" v-slot="{ errors }">
                <small class="label">Accreditation Expiration Date</small>
<!--                <datepicker name="expiry" v-model="accreditation.expiry"></datepicker>-->
                <flat-pickr
                  style="display: none"
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y'}"
                  v-model="accreditation.expiry"
                  placeholder="Choose Date"
                />
                <flat-pickr placeholder="Choose Date" class="w-full" v-model="accreditation.expiry" :config="{ dateFormat: 'd/m/Y'}" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
                <!--                <vs-input type="date" v-model="accreditation.expiry" :danger="errors[0]" :danger-text="errors[0]"  name="acc_expiry"  class="w-full required" label="" />-->
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col w-1/4">
              <ValidationProvider v-if="accreditation && accreditation.name !== 'None'" :vid="index+'level_of_approval'" :name="index+'level_of_approval'" rules="required" v-slot="{ errors }">
                <small class="label">Accreditation Level of Approval</small>
                <vs-input v-model="accreditation.level_of_approval" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="acc_grade"  class="w-full required" label="" />
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/4">
              <ValidationProvider v-if="accreditation && accreditation.name !== 'None'" :vid="index+'grade'" :name="index+'grade'" rules="required" v-slot="{ errors }">
                <small class="label">Accreditation Grade</small>
                <vs-input v-model="accreditation.grade" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="grade"  class="w-full required" label="" />
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/4">
              <vs-button v-if="accreditation && accreditation.name !== 'None'" color="danger" icon="delete"  @click="deleteAccreditation(index)" type="border" class="ml-auto mt-6 w-full" >Delete</vs-button>
            </div>
          </div>
          <vs-divider v-if="accreditation && accreditation.name !== 'None'" class="mt-12 mb-12"  color="secondary" style="opacity: 0.2" position="center"></vs-divider>
        </div>
<!--        <vs-button v-if="accreditations && accreditations[0].name !== 'None'"  @click="addAccreditation" radius color="primary" type="filled" icon="add"></vs-button>-->
        <vs-button v-if="accreditations && accreditations[0].name !== 'None'"  @click="addAccreditation" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add Accreditation</vs-button>


        <div class="vx-row mb-3 mt-8" v-if="accreditations && accreditations[0].name === 'None'">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="document_quality_no" name="document_quality_no" rules="required" v-slot="{ errors }">
              <small class="label">4.2 If no, is there a documented quality system and is certification planned? </small>
              <vs-input type="text" name="document_quality_no" class="w-full" v-model="form.document_quality_no"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3 mt-4" v-if="accreditations && accreditations[0].name === 'None'">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="document_reviewed" name="document_reviewed" rules="" v-slot="{ errors }">
              <small class="label">4.3 How often is it reviewed?</small>
              <v-select :closeOnSelect="true" v-model="form.document_reviewed" :options="['weekly', 'monthly','quarterly', 'half-yearly', 'yearly']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_company_registered_environment" name="is_company_registered_environment" rules="" v-slot="{ errors }">
              <small class="label">4.4 Is the company registered with the local Environmental Health department?</small>
              <vs-switch v-model="form.is_company_registered_environment" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_company_registered_environment" vid="is_company_registered_environment_text" name="is_company_registered_environment_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_company_registered_environment_text" class="w-full" v-model="form.is_company_registered_environment_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>


        <!--        <vs-divider color="primary" border-style="dashed" class="mt-16" position="left">4.5 Do you document and retain?</vs-divider>-->
        <div class="vx-row mt-8 mb-4">
          <div class="vx-col md:w-full md:mb-0">
            <small>4.5 Do you document and retain?</small>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_document_raw_material" name="is_document_raw_material" rules="" v-slot="{ errors }">
              <small class="label">a. Raw material inspection records</small>
              <vs-switch v-model="form.is_document_raw_material" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_document_raw_material" vid="is_document_raw_material_text" name="is_document_raw_material_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_document_raw_material_text" class="w-full" v-model="form.is_document_raw_material_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>


        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_document_procedures" name="is_document_procedures" rules="" v-slot="{ errors }">
              <small class="label">b. All processing and packing procedures</small>
              <vs-switch v-model="form.is_document_procedures" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_document_procedures" vid="is_document_procedures_text" name="is_document_procedures_text" rules="required" v-slot="{ errors }">
              <small class="label"> If yes,please specify</small>
              <vs-input type="text" name="is_document_procedures_text" class="w-full" v-model="form.is_document_procedures_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_document_records" name="is_document_records" rules="" v-slot="{ errors }">
              <small class="label">c. Quality control records</small>
              <vs-switch v-model="form.is_document_records" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_document_records" vid="is_document_records_text" name="is_document_records_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_document_records_text" class="w-full" v-model="form.is_document_records_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>




        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_document_audit" name="is_document_audit" rules="" v-slot="{ errors }">
              <small class="label">d. Quality system audits</small>
              <vs-switch v-model="form.is_document_audit" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_document_audit" vid="is_document_audit_text" name="is_document_audit_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_document_audit_text" class="w-full" v-model="form.is_document_audit_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <!--        <vs-divider color="primary" border-style="dashed" class="mt-16" position="left">4.6 Are your suppliers approved by:</vs-divider>-->
        <div class="vx-row mt-8 mb-4">
          <div class="vx-col md:w-full md:mb-0">
            <small>4.6 Are your suppliers approved by:</small>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_previous_record" name="is_previous_record" rules="" v-slot="{ errors }">
              <small class="label">a. Previous satisfactory supply record?</small>
              <vs-switch v-model="form.is_previous_record" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_previous_record" vid="is_previous_record_text" name="is_previous_record_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_previous_record_text" class="w-full" v-model="form.is_previous_record_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_self_audit" name="is_self_audit" rules="" v-slot="{ errors }">
              <small class="label">b. Self audit questionnaire?</small>
              <vs-switch v-model="form.is_self_audit" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_self_audit" vid="is_self_audit_text" name="is_self_audit_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_self_audit_text" class="w-full" v-model="form.is_self_audit_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_suppliers_permises" name="is_suppliers_permises" rules="" v-slot="{ errors }">
              <small class="label">c. Audit of supplier’s premises?</small>
              <vs-switch v-model="form.is_suppliers_permises" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_suppliers_permises" vid="is_suppliers_permises_text" name="is_suppliers_permises_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_suppliers_permises_text" class="w-full" v-model="form.is_suppliers_permises_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_suppliers_third_party" name="is_suppliers_third_party" rules="" v-slot="{ errors }">
              <small class="label">d. Third party accreditation of suppliers premises?</small>
              <vs-switch v-model="form.is_suppliers_third_party" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_suppliers_third_party" vid="is_suppliers_third_party_text" name="is_suppliers_third_party_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_suppliers_third_party_text" class="w-full" v-model="form.is_suppliers_third_party_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_supplier_approved_other" name="is_supplier_approved_other" rules="" v-slot="{ errors }">
              <small class="label">e. Other (Please State)?</small>
              <vs-switch v-model="form.is_supplier_approved_other" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_supplier_approved_other" vid="is_supplier_approved_other_text" name="is_supplier_approved_other_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_supplier_approved_other_text" class="w-full" v-model="form.is_supplier_approved_other_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_agreed_specification" name="is_agreed_specification" rules="" v-slot="{ errors }">
              <small class="label">4.7 Are all raw materials purchased against an agreed specification?</small>
              <vs-switch v-model="form.is_agreed_specification" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_agreed_specification" vid="is_agreed_specification_text" name="is_agreed_specification_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_agreed_specification_text" class="w-full" v-model="form.is_agreed_specification_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_documented_conform" name="is_documented_conform" rules="" v-slot="{ errors }">
              <small class="label">4.8 Is there a documented procedure for ensuring that raw materials conform to specification? If yes,please specify</small>
              <vs-switch v-model="form.is_documented_conform" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_documented_conform" vid="is_documented_conform_text" name="is_documented_conform_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_documented_conform_text" class="w-full" v-model="form.is_documented_conform_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_satisfied_safety_steps" name="is_satisfied_safety_steps" rules="" v-slot="{ errors }">
              <small class="label">4.9 Are you satisfied that your own suppliers are taking all reasonable steps to ensure the safety of products which you purchase?</small>
              <vs-switch v-model="form.is_satisfied_safety_steps" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_satisfied_safety_steps" vid="is_satisfied_safety_steps_text" name="is_satisfied_safety_steps_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_satisfied_safety_steps_text" class="w-full" v-model="form.is_satisfied_safety_steps_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_packing_comply" name="is_packing_comply" rules="" v-slot="{ errors }">
              <small class="label">4.10 Are you satisfied that your own suppliers are taking all reasonable steps to ensure the safety of products which you purchase?</small>
              <vs-switch v-model="form.is_packing_comply" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_packing_comply" vid="is_packing_comply_text" name="is_packing_comply_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_packing_comply_text" class="w-full" v-model="form.is_packing_comply_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_trace_materials" name="is_trace_materials" rules="" v-slot="{ errors }">
              <small class="label">4.11 Is the company able to trace materials from at least one level down and one level up? Please provide a copy of a trace</small>
              <vs-switch v-model="form.is_trace_materials" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_trace_materials" vid="" rules="" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <a target="_blank" v-if="form.is_trace_materials_file" class="float-right" :href="form.is_trace_materials_file">view file</a>
              <vs-input @change="onUploadFile($event)" type="file" class="w-full" />  <!-- v-model="form.is_trace_materials_file" -->
              <span v-if="formUploadRequired" class="text-danger text-sm">This field is required</span>
            </ValidationProvider>
          </div>
        </div>

        <!--        <vs-divider color="primary" border-style="dashed" class="mt-16" position="left">4.12</vs-divider>-->
        <div class="vx-row mt-8 mb-4">
          <div class="vx-col md:w-full md:mb-0">
            <small>4.12</small>
          </div>
        </div>


        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_crisis_management_documented" name="is_crisis_management_documented" rules="" v-slot="{ errors }">
              <small class="label">a. Does the company have a documented Product Recall/ Crisis Management Procedure?</small>
              <vs-switch v-model="form.is_crisis_management_documented" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_crisis_management_documented" vid="is_crisis_management_documented_text" name="is_crisis_management_documented_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_crisis_management_documented_text" class="w-full" v-model="form.is_crisis_management_documented_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3" v-if="form.is_crisis_management_documented">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="crisis_last_tested" name="crisis_last_tested" rules="required" v-slot="{ errors }">
              <small class="label">b. When was this last tested?</small>
              <!--              <vs-input type="date" name="crisis_last_tested" class="w-full" v-model="form.crisis_last_tested" />-->
              <flat-pickr
                style="display: none"
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="form.crisis_last_tested"
                placeholder="Choose Date"
              />
              <flat-pickr placeholder="Choose Date" class="w-full" v-model="form.crisis_last_tested" :config="{ dateFormat: 'd/m/Y'}" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_document_complain" name="is_document_complain" rules="" v-slot="{ errors }">
              <small class="label">4.13 Do you have a documented Complaints Procedure? If so, how frequently is the complaints data assessed? Give details</small>
              <vs-switch v-model="form.is_document_complain" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_document_complain" vid="is_document_complain_text" name="is_document_complain_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_document_complain_text" class="w-full" v-model="form.is_document_complain_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <!--        <vs-divider color="primary" border-style="dashed" class="mt-16" position="left">4.14</vs-divider>-->
        <div class="vx-row mt-8 mb-4">
          <div class="vx-col md:w-full md:mb-0">
            <small>4.14</small>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_qms_audits" name="is_qms_audits" rules="" v-slot="{ errors }">
              <small class="label">a. Does the company carry out internal audits of QMS, GMP and Hygiene? If yes, have the auditors been formally trained and are they independent of the area being audited?</small>
              <vs-switch v-model="form.is_qms_audits" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_qms_audits" vid="is_qms_audits_text" name="is_qms_audits_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_qms_audits_text" class="w-full" v-model="form.is_qms_audits_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <div class="row mb-3" v-if="form.is_qms_audits">
          <div class="vx-col md:w-ful w-full md:mb-0">
            <ValidationProvider vid="audit_frequency" name="audit_frequency" rules="required" v-slot="{ errors }">
              <small class="label">b. What is the audit frequency?</small>
              <v-select name="audit_frequency" :closeOnSelect="true" v-model="form.audit_frequency" :options="['weekly', 'monthly', 'quarterly', 'half-yearly','yearly']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_prosecution" name="is_prosecution" rules="" v-slot="{ errors }">
              <small class="label">4.15 Has the company had any prosecutions, criminal or civil, related to food safety and/ or environment in the past 3 years? If yes,please specify</small>
              <vs-switch v-model="form.is_prosecution" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_prosecution" vid="is_prosecution_text" name="is_prosecution_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_prosecution_text" class="w-full" v-model="form.is_prosecution_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_coa_delivered" name="is_coa_delivered" rules="" v-slot="{ errors }">
              <small class="label">4.16 Do you supply a COC or a COA to accompany each delivery?</small>
              <vs-switch v-model="form.is_coa_delivered" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_coa_delivered" vid="is_coa_delivered_text" name="is_coa_delivered_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_coa_delivered_text" class="w-full" v-model="form.is_coa_delivered_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_legal_obligation" name="is_legal_obligation" rules="" v-slot="{ errors }">
              <small class="label">4.17 Does the Company recognise its legal obligation to comply with the Food Safety Act 1990 and all subsequent legislation?</small>
              <vs-switch v-model="form.is_legal_obligation" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_legal_obligation" vid="is_legal_obligation_text" name="is_legal_obligation_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_legal_obligation_text" class="w-full" v-model="form.is_legal_obligation_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            </ValidationProvider>
          </div>
        </div>


        <div class="mt-12 flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_supplier_manufacture_site_quality_complete === 1"  button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4">Save and Change</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRepository = RepositoryFactory.get('supplier');
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment'

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  export default {
    name: "SupplierManufacturingHome",
    mixins: [SuccessMessage, ErrorMessages],
    data() {
      return {
        form: {
          is_company_registered_environment: false,
          is_document_raw_material: false,
          is_document_procedures: false,
          is_document_records: false,
          is_document_audit: false,
          is_previous_record: false,
          is_self_audit: false,
          is_suppliers_permises: false,
          is_suppliers_third_party: false,
          is_supplier_approved_other: false,
          is_agreed_specification: false,
          is_documented_conform: false,
          is_satisfied_safety_steps: false,
          is_packing_comply: false,
          is_trace_materials: false,
          is_crisis_management_documented: false,
          is_document_complain: false,
          is_qms_audits: false,
          is_prosecution: false,
          is_coa_delivered: false,
          is_legal_obligation: false,
        },
        status: {},
        id: null,
        accreditations: [
          {name: '', details: '', expiry: '', level_of_approval: '', grade: '', licence_number: ''}
        ],
        formUploadRequired: false
      }
    },components: {
      'v-select': vSelect,
      Datepicker,
      flatPickr
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      deleteAccreditation: function(index) {
        this.accreditations.splice(index, 1)
      },
      addAccreditation() {
        this.accreditations.push(
          {name: '', details: '', expiry: '', level_of_approval: '', grade: '', licence_number: ''}
        )
      },
      onClickSubmit() {
        this.status.is_supplier_manufacture_site_quality_complete === 1 ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        if (this.form.is_trace_materials && !this.form.is_trace_materials_file) {
          this.formUploadRequired = true
        } else {
          this.$vs.loading()
          try {
            this.form.accreditations = this.accreditations[0].name === 'None' ? [] : this.accreditations

            const data= (await SupplierManufactureRepository.UpdateManufactureQualityDetails(this.id, this.form))
            this.showSuccessMessage('Manufacture Quality Details Updated!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }

      },
      async onClickCreate() {
        if (this.form.is_trace_materials && !this.form.is_trace_materials_file) {
          this.formUploadRequired = true
        } else {
          this.$vs.loading()
          try {
            this.form.accreditations = this.accreditations[0].name === 'None' ? [] : this.accreditations

            // this.form.accreditations = this.accreditations
            const data= (await SupplierManufactureRepository.CreateManufactureQualityDetails(this.form))
            this.showSuccessMessage('Manufacture Quality Details Created!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },
      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureQualityDetails(this.id)).data
        this.form =data
        this.accreditations = this.form.supplier_manufacture_site_quality_accreditation
        if (this.accreditations.length === 0) {
          this.accreditations.push(
            {name: 'None', details: '', expiry: '', level_of_approval: '', grade: '', licence_number: ''}
          )
        }
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureSiteStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      async onUploadFile(event) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.is_trace_materials_file = (await SupplierRepository.uploadFile(formData)).data.data.file
          this.formUploadRequired = false
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_manufacture_site_id =  this.id
      await this.loadStatus()
      if (this.status.is_supplier_manufacture_site_quality_complete === 1 ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
